import React from "react";
import { cn } from "../lib/utils";

const TONE_STYLES = {
  default: "border-gray-200 bg-white text-gray-900",
  warning: "border-amber-200 bg-amber-50 text-amber-800",
  danger: "border-red-200 bg-red-50 text-red-700",
  success: "border-emerald-200 bg-emerald-50 text-emerald-700",
};

/** Operational KPI strip - every card is a live, clickable figure (never decorative), per the
 * Payroll/Leave Deep Audit standard: link straight to the filtered view the number represents. */
export function KpiStrip({ items, testId }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-testid={testId}>
      {items.map((item, i) => {
        const Comp = item.onClick ? "button" : "div";
        return (
          <Comp
            key={i}
            type={item.onClick ? "button" : undefined}
            onClick={item.onClick}
            data-testid={item.testId}
            className={cn(
              "rounded-xl border p-3.5 text-left transition-colors",
              TONE_STYLES[item.tone || "default"],
              item.onClick && "hover:shadow-sm hover:border-blue-300 cursor-pointer"
            )}
          >
            <p className="text-2xl font-bold leading-none">{item.value}</p>
            <p className="text-[11px] uppercase tracking-wide mt-1.5 opacity-70">{item.label}</p>
          </Comp>
        );
      })}
    </div>
  );
}
